import React from 'react'
import { CalendarIcon, ClockIcon } from 'src/assets/svg'
import { useStyles } from './styles'
import { AnimalRecordDto } from 'src/dto/animal.dto'
import { formatDate, formatTime } from '../../views/utils/functions'

type MovementRecordCardProps = {
  data: AnimalRecordDto
}
export const MovementRecordCard: React.FC<MovementRecordCardProps> = ({ data }) => {
  const styles = useStyles()

  const date = data.data

  return (
    <div className={styles.cardContainer}>
      <div>
        <div className={styles.cardHeaderContainer}>
          <h3>{data.username || 'Usuário'}</h3>
          <div className={styles.cardHeaderHourInfoContainer}>
            <span>
              <ClockIcon />
            </span>
            <span className={styles.cardSpanText}>{formatTime(date)}</span>
          </div>
        </div>
        <div className={styles.cardHeaderDateContainer}>
          <span>
            <CalendarIcon />
          </span>
          <span className={styles.cardSpanDateText}>{formatDate(date)}</span>
        </div>
      </div>
      <div className={styles.cardTextContainer}>
        {data?.listaModificados?.observacoes?.map((record, index) => (
          <p key={index} className={styles.cardParagraphText}>
            {record}
          </p>
        ))}
      </div>
    </div>
  )
}
